import Events from "./events";

export default class GameListeners {
    constructor(gb) {
        //for SPIN games to Playtech wallet do not add event listeners
        if (gb.passThrough2Playtech) {
            this.gb = gb;
        } else {
            Object.assign(this, { gb, ...(new Events(gb).exposeEvents()) })
        }
    }
}
